export default class OperatorService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getFormData() {
		return this.apiService.callGet('operators/form_data')
	}

	getLoggedOperator() {
		return this.apiService.callGet('operators/logged')
	}

	getOperators(params = {}) {
		return this.apiService.callGet('operators/simple_list', params);
	}

	getEntities(params) {
		return this.apiService.callGet('operators', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('operators/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('operators', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('operators/' + id, params)
	}

	updateOperatorSettings(id, params){
		return this.apiService.callPut('operators/' + id + '/operatorSettings', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('operators/' + id, params)
	}

	uploadLogo(id, file) {
		return this.apiService.callPost('operators/' + id + '/logo', file)
	}

	deleteLogo(id) {
		return this.apiService.callDelete('operators/' + id + '/logo')
	}

	getProgramStructure(params) {
		return this.apiService.callGet('operators/programming_structure', params)
	}

	getOperatorConfiguration(id) {
		return this.apiService.callGet('operators/' + id + '/configuration')
	}

	// SEARCH
	searchOperatorsForRecipients(params) {
		return this.apiService.callGet('operators/operators_search', params)
	}

}



// WEBPACK FOOTER //
// ./src/service/OperatorService.js